import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import PaymentValidationViewModel from "../../viewModels/paymentValidation/paymentValidationViewModel";
import { registerWidget } from "../widget";

const PaymentValidationWidgetIdentifier = "edaz-payment-validation";

registerWidget({
  component: makeWidgetFor(PaymentValidationWidgetIdentifier, [PaymentValidationViewModel], BasicInitializationService),
  configuration: {
    tagname: PaymentValidationWidgetIdentifier,
  },
});
